$(function () {

    $('.slider').bxSlider({
        auto: true,
        pause: 5000,
        pager: false,
        autoHover: true,
        adaptiveHeight: false
    });

    $('#about-clients').bxSlider({
        auto: true,
        pause: 3000,
        pager: false,
        controls: false,
        autoHover: false,
        adaptiveHeight: false,
        slideWidth: 200,
        minSlides: 1,
        maxSlides: 4

    });

    $('#checkbox').change(function () {
        setInterval(function () {
            moveRight();
        }, 3000);
    });

    $('.page-item__menu-list a').click(function () {
        var anc = $(this).attr('href');
        var ancOffset = $(anc).offset().top;
        $('html, body').stop().animate({scrollTop: ancOffset}, 500, 'swing');
    });

    // $('.fancy').fancybox();

    $('.catalog__list-main a').click(function () {
        var ancOffset = $($(this).attr('href')).offset().top;
        $('html, body').stop().animate({scrollTop: ancOffset}, 500, 'swing');
    });

    $('.up').click(function () {
        $('html, body').stop().animate({scrollTop: 0}, 500, 'swing');
    });

    if ($(document).scrollTop() < 500) {
        $('.up').hide()
    } else {
        $('#cart').addClass('floated').fadeIn('slow');
    }


    if ($(window).width() < 750) {
        $('.watsap').addClass('mob')
    }

    var inAction = false;
    $(window).scroll(function () {
        if ($(document).scrollTop() > 500) {
            if (inAction === false) {
                inAction = true;
                $('.up').fadeIn('slow');
                $('#cart').addClass('floated').animate({
                    opacity: 1
                }, 500, function () {
                    inAction = false;
                });
            }
        } else {
            $('.up').fadeOut('slow');

            if ($('#cart').hasClass('floated')) {
                if (inAction === false) {
                    inAction = true;
                    $('#cart').animate({
                        opacity: 0
                    }, 500, function () {
                        $('#cart').removeClass('floated').css('opacity', 1);
                        inAction = false;
                    });
                }
            }
        }
    });

    $('.add-to-cart').on('click', function () {
        var el = $(this);

        if (el.hasClass('added')) {
            return true;
        }

        $.get('/order/add-to-cart/', {
                id: el.data('id'),
                loan: el.hasClass('loan')? 1 : 0,
            },
            function (response) {
                el.addClass('added');
                $('#cart').html('<span class="menu-cart__text">' + parseInt(response.quantity) + '</span>');
                if (el.hasClass('is_cart')) {
                    location.reload();
                }
            }, 'json');

        return false;
    });

});
